import "./App.scss";
import { RouterControl } from "../router";

function App() {
  return <RouterControl />;
}

export default App;
